import { Controller } from "@hotwired/stimulus"

// Clones hidden field templates and appends them, or removes field groups.
// Used by references/_mls_form and references/_license_form.
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const clone = this.templateTarget.cloneNode(true)
    clone.querySelectorAll("input").forEach(input => input.value = "")
    clone.classList.remove("hidden_fields")
    clone.removeAttribute("style")
    this.containerTarget.appendChild(clone)
    event.target.blur()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-dynamic-fields-target='template']").remove()
  }
}
